"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandaloneFormSubmit = exports.FormSubmit = void 0;

var react_1 = __importDefault(require("react"));

var react_hook_form_1 = require("react-hook-form");

var Button_1 = require("../ant/Button");

var isNative_1 = require("../isNative");

var Form_1 = require("./Form");

function FormSubmit(_a) {
  var disableUntilDirty = _a.disableUntilDirty,
      _a$loadingWhenSubmitt = _a.loadingWhenSubmitting,
      loadingWhenSubmitting = _a$loadingWhenSubmitt === void 0 ? true : _a$loadingWhenSubmitt,
      rest = __rest(_a, ["disableUntilDirty", "loadingWhenSubmitting"]);

  var _ref = (0, Form_1.useReactFormContext)(),
      handleSubmit = _ref.handleSubmit;

  var _ref2 = (0, react_hook_form_1.useFormState)(),
      isDirty = _ref2.isDirty,
      isValid = _ref2.isValid,
      isSubmitting = _ref2.isSubmitting;

  var isDisabled = rest.disabled || disableUntilDirty && !isDirty || isNative_1.isNative && !isValid;
  var isLoading = rest.loading || loadingWhenSubmitting && isSubmitting;
  return react_1.default.createElement(Button_1.Button, Object.assign({
    children: 'Submit',
    type: 'primary'
  }, rest, {
    disabled: isDisabled,
    loading: isLoading,
    onClick: handleSubmit
  }));
}

exports.FormSubmit = FormSubmit;

function StandaloneFormSubmit(_a) {
  var form = _a.form,
      onFinish = _a.onFinish,
      rest = __rest(_a, ["form", "onFinish"]);

  return react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, form), react_1.default.createElement(Form_1.ReactFormContextProvider, {
    form: form,
    onFinish: onFinish
  }, react_1.default.createElement(FormSubmit, Object.assign({}, rest))));
}

exports.StandaloneFormSubmit = StandaloneFormSubmit;